(function ($, Cobalt, undefined) {
	Cobalt.PopOut = {
		initialize: function () {
			var anchor = $(".user-action-pop-out").find("a");
			$(anchor).click(function (event) {
				var url = $(this).attr("data-pop-out-url");
				if (url == "" || url == null) {
					url = $(this).attr("href");
				}
				window.open(url, "test", "status=0,toolbar=0,location=0,menubar=0,resizable=1,scrollbars=1,width=760,height=505");
				event.preventDefault();
				return false;
			});
		}
	};

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.PopOut.js